<div class="" [formGroup]="userForm">
  <div class="formfield" [id]="hasEmailTooltip ? '' : 'bca-user-form'">
    <nes-message-inline
      class="nes-my-5"
      *ngIf="isSignatoryStatusNotValid() === true"
      [label]="'INPUT.NO_SIGNATORY_WARNING.LABEL' | translate"
      type="error"
      close="false"
    >
      {{ "INPUT.NO_SIGNATORY_WARNING.CONTENT" | translate }}
      <br />
      <br />
      <nes-button
        nes-href="https://www.ns.nl/zakelijk/formulieren/aanvragen-overeenkomst-ns-business-cards?bca_flow=true"
        >{{ "INPUT.NO_SIGNATORY_WARNING.BUTTON" | translate }}</nes-button
      >
    </nes-message-inline>

    <nes-heading tag="h2" size="md" class="nes-mb-2">
      {{ "INPUT.GENDER.LABEL" | translate }}
    </nes-heading>
    <div class="">
      <ul [cypress]="'gender'" class="list formfield__inputGroup">
        <li
          *ngFor="let gender of genders"
          class="list__item formfield__inputGroupItem"
        >
          <div class="radioButton">
            <input
              [formControl]="getControl('gender')"
              [id]="gender.value + gender.id"
              [cypress]="gender.value"
              [value]="gender.value"
              type="radio"
              class="radioButton__input"
              [name]="gender.id"
              tabindex="-1"
              privacySensitive
            />
            <label
              class="radioButton__label"
              [for]="gender.value + gender.id"
              tabindex="-1"
            >
              {{ gender.displayText | translate }}
            </label>
          </div>
        </li>
      </ul>
    </div>
    @if (getGenderErrorKey() !== undefined) {
      <nes-error-message>
        {{ getGenderErrorKey() | translate }}
      </nes-error-message>
    }
  </div>

  <div class="formfield">
    <nes-input
      [label]="'INPUT.INITIALS.LABEL' | translate"
      [value]="userForm.get('initials')!.value"
      [name]="'INPUT.INITIALS.NAME' | translate"
      [formControl]="getControl('initials')"
      formControlName="initials"
      nesFormControl
      required
      controlled
      (nesOnKeyDown)="_uiService.isOnlyLettersInInitials($event)"
      maxLength="10"
      [cypress]="'initials'"
      receiptFooterVisibility
      privacySensitive
      formatInitials
      formatInitialsIE
      nes-id="initials"
      type="text"
    ></nes-input>
    @if (getInitialsErrorKey() !== undefined) {
      <nes-error-message>
        {{ getInitialsErrorKey() }}
      </nes-error-message>
    }
  </div>

  <bca-middle-name [middleNames]="middleNames" [userForm]="formGroup">
  </bca-middle-name>

  <div class="formfield">
    <div class="">
      <nes-input
        [label]="'INPUT.LASTNAME.LABEL' | translate"
        [name]="'INPUT.LASTNAME.NAME' | translate"
        [value]="formGroup.get('lastName')!.value"
        [formControl]="getControl('lastName')"
        formControlName="lastName"
        nesFormControl
        required
        controlled
        (nesOnKeyDown)="_uiService.isIgnoreNumbersInLastName($event)"
        maxLength="40"
        [cypress]="'last_name'"
        privacySensitive
        [forceUppercase]="{ firstLetterOnly: true }"
        receiptFooterVisibility
        nes-id="lastName"
        type="text"
      ></nes-input>
      @if (getLastNameErrorKey() !== undefined) {
        <nes-error-message>
          {{ getLastNameErrorKey() }}
        </nes-error-message>
      }
    </div>
  </div>

  <div class="formfield">
    <div class="">
      <nes-input
        [label]="'COMPANY_DATA.INPUT.PHONE_NUMBER.LABEL' | translate"
        [value]="formGroup.get('phoneNumber')!.value"
        [name]="'COMPANY_DATA.INPUT.PHONE_NUMBER.NAME' | translate"
        [formControl]="getControl('phoneNumber')"
        formControlName="phoneNumber"
        required
        nesFormControl
        controlled
        maxLength="10"
        [cypress]="'phone_number'"
        receiptFooterVisibility
        privacySensitive
        nes-id="phoneNumber"
        type="number"
      ></nes-input>
      @if (getPhoneNumberErrorKey() !== undefined) {
        <nes-error-message>
          {{ getPhoneNumberErrorKey() }}
        </nes-error-message>
      }
    </div>
  </div>

  <div class="formfield">
    <div class="">
      <nes-input
        formControlName="email"
        type="email"
        [label]="'INPUT.EMAIL.LABEL' | translate"
        [cypress]="'email'"
        [name]="'INPUT.EMAIL.NAME' | translate"
        [value]="formGroup.get('email')!.value"
        [formControl]="getControl('email')"
        nesFormControl
        controlled
        maxLength="50"
        nes-id="email"
        receiptFooterVisibility
        privacySensitive
        forceLowercase
        noSpace
        required
        [tooltip]="'INPUT.EMAIL.TOOLTIP' | translate"
      ></nes-input>
      @if (getEmailErrorKey() !== undefined) {
        <nes-error-message>
          {{ getEmailErrorKey() }}
        </nes-error-message>
      }
    </div>
  </div>

  <div class="formfield">
    <div class="">
      <nes-input
        [label]="'COMPANY_DATA.INPUT.DEPARTMENT.LABEL' | translate"
        [name]="'COMPANY_DATA.INPUT.DEPARTMENT.NAME' | translate"
        [value]="formGroup.get('department')!.value"
        [formControl]="getControl('department')"
        nes-id="department"
        nesFormControl
        controlled
        maxLength="100"
        [cypress]="'department'"
        receiptFooterVisibility
        privacySensitive
        type="text"
      ></nes-input>
    </div>
  </div>
</div>
